<template>
  <div class="carga-wrapper">

    <!-- ── Barra de acciones ──────────────────────────────────────── -->
    <br>
    <div class="action-bar mb-3">
      <button
        v-if="p_numSemana === 0 || (!cargaActivaSinArchivos && p_numSemana + 1 <= p_maxSemana)"
        class="action-btn action-btn--primary"
        @click="abrirModalCrear"
        title="Cargar semana"
      >
        <span class="material-symbols-outlined">upload_file</span>
        Cargar semana {{ p_numSemana + 1 }}
      </button>
    </div>

    <!-- ── Selector registros por página ─────────────────────────── -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="cargas.length > 0">
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select
        v-model.number="elementosPorPagina"
        class="form-select form-select-sm"
        style="width: 75px;"
        @change="getDataPaginaTodos(1)"
      >
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- ── Tabla ──────────────────────────────────────────────────── -->
    <div class="table-responsive" v-if="cargas.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <tr>
            <th>Fecha desde</th>
            <th>Fecha hasta</th>
            <th>Registros</th>
            <th>Errores</th>
            <th>Novedades</th>
            <th>Acciones</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="carga in datosPaginados"
            :key="carga.idCarga"
            @dblclick="handleRowClick($event, carga.idCarga)"
            title="Doble clic para ver resumen"
            :class="{
              'table-danger':    carga.tieneErrores === 1 && carga.estado === 1,
              'table-secondary': carga.tieneErrores === 1 && carga.estado === 0,
            }"
          >
            <td>{{ getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY') }}</td>
            <td>{{ getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY') }}</td>
            <td>
              <span class="badge bg-primary">{{ carga.numeroRegistros }}</span>
            </td>
            <td>
              <span class="badge" :class="carga.tieneErrores === 1 ? 'bg-danger' : 'bg-success'">
                {{ carga.tieneErrores === 1 ? 'Sí' : 'No' }}
              </span>
            </td>
            <td>
              <span class="badge" :class="carga.tieneNovedades === 1 ? 'bg-warning text-dark' : 'bg-success'">
                {{ carga.tieneNovedades === 1 ? 'Sí' : 'No' }}
              </span>
            </td>
            <td>
              <div class="icon-btns">
                <button
                  v-if="carga.tienePlanillas === 0"
                  class="icon-btn icon-btn--green"
                  @click.prevent="generarAtenciones(carga.idCarga)"
                  title="Organizar Atenciones Médicas"
                >
                  <span class="material-symbols-outlined">medical_services</span>
                </button>
                <button
                  class="icon-btn icon-btn--red-soft"
                  @click.prevent="borrarCargaCompleta(carga.idCarga)"
                  title="Borrar carga completa"
                >
                  <span class="material-symbols-outlined">delete_forever</span>
                </button>
                <button
                  class="icon-btn icon-btn--red-soft"
                  @click.prevent="borrarCargaTramite(carga.idCarga)"
                  title="Borrar carga trámite"
                >
                  <span class="material-symbols-outlined">delete_forever</span>
                </button>
                <button
                  v-if="carga.tienePlanillas === 1 && carga.tieneArchivos === 0"
                  class="icon-btn icon-btn--teal"
                  @click.prevent="abrirModalArchivos(carga.idCarga)"
                  title="Carga de Archivos"
                >
                  <span class="material-symbols-outlined">drive_folder_upload</span>
                </button>
                <span
                  v-if="carga.tieneErrores === 1 && carga.estado === 0"
                  class="badge bg-secondary"
                >
                  <span class="material-symbols-outlined" style="font-size:11px;vertical-align:middle">block</span>
                  Borrada
                </span>
              </div>
            </td>
            <td>
              <select
                class="form-select form-select-sm"
                @change="handleAction($event, carga.idCarga,
                  getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY'),
                  getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY'))"
              >
                <option disabled selected>Seleccione...</option>
                <option value="resumen">Resumen</option>
                <option v-if="carga.tieneErrores === 1"   value="errores">Errores</option>
                <option v-if="carga.tieneNovedades === 1" value="novedades">Novedades</option>
                <option v-if="carga.tienePlanillas === 1" value="zipAtenciones1">ZIP Carpetas</option>
                <option v-if="carga.tienePlanillas === 1" value="zipAtenciones2">ZIP Carpetas, día</option>
                <option v-if="carga.tienePlanillas === 1" value="zipAtenciones3">ZIP Carpetas, día y especialidad</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="7" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ cargas.length }} cargas
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- ── Sin resultados ─────────────────────────────────────────── -->
    <div v-if="cargas.length === 0" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros de carga.
    </div>

    <!-- ── Paginación ─────────────────────────────────────────────── -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="cargas.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ cargas.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage()">‹</a>
          </li>
          <li
            v-for="pagina in totalPaginas()"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual }"
          >
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(pagina)">{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage()">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         MODAL
    ═══════════════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :aria-hidden="isModalOpen ? 'false' : 'true'"
      :inert="!isModalOpen"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- Header estándar -->
          <div class="modal-header bg-primary">
            <span class="material-symbols-outlined text-white me-2" style="font-size:22px">
              {{ opcionModal === 'crear'   ? 'upload_file'
               : opcionModal === 'resumen' ? 'summarize'
               : 'folder_open' }}
            </span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="isModalOpen = false"
            ></button>
          </div>

          <!-- ── Crear: tabs de tipo de archivo ── -->
          <div v-if="opcionModal === 'crear'" class="modal-body">
            <ul class="nav nav-tabs mb-3" id="cargaTabs" role="tablist">
              <li class="nav-item" v-for="(option, index) in uploadOptions" :key="option.id" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: index === 0 }"
                  :id="`${option.id}-tab`"
                  data-bs-toggle="tab"
                  :data-bs-target="`#${option.id}`"
                  type="button"
                  role="tab"
                >
                  {{ option.tabLabel }}
                </button>
              </li>
            </ul>

            <div class="tab-content">
              <div
                v-for="(option, index) in uploadOptions"
                :key="option.id"
                class="tab-pane fade"
                :class="{ 'show active': index === 0 }"
                :id="option.id"
                role="tabpanel"
              >
                <div class="upload-zone">
                  <div class="upload-zone-icon">
                    <span class="material-symbols-outlined">cloud_upload</span>
                  </div>
                  <p class="upload-zone-desc">
                    Carga un archivo <strong>{{ option.extensionsLabel }}</strong> con el
                    <a
                      href="/docs/Estructura del archivo para la carga de datos de atenciones médicas.pdf"
                      target="_blank" rel="noopener noreferrer" class="upload-link"
                    >formato establecido</a>.
                    Asegúrate de que cumpla las especificaciones antes de cargarlo.
                  </p>
                  <form @submit.prevent="uploadFile(option.tipo)" class="w-100">
                    <div class="row align-items-end g-3 justify-content-center">
                      <div class="col-md-5">
                        <label class="form-label fw-bold small">{{ option.tabLabel }}</label>
                        <input
                          type="file"
                          :id="option.inputId"
                          class="form-control form-control-sm"
                          @change="handleFileUpload"
                          :accept="option.accept"
                          required
                        />
                        <small class="form-text text-muted">{{ option.helpText }}</small>
                      </div>
                      <div class="col-md-auto">
                        <button type="submit" class="btn btn-outline-success d-flex align-items-center gap-1">
                          <span class="material-symbols-outlined" style="font-size:20px">upload_file</span>
                          <strong>{{ option.buttonText }}</strong>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- ── Resumen ── -->
          <div v-if="opcionModal === 'resumen'" class="modal-body">
            <div class="row mb-2">
              <div class="col-2"><label class="form-label fw-bold">IdCarga</label></div>
              <div class="col-4"><span>{{ datoCarga.idCarga }}</span></div>
              <div class="col-2"><label class="form-label fw-bold">Tamaño Archivo</label></div>
              <div class="col-4"><span>{{ datoCarga.tamanioArchivo }}</span></div>
            </div>
            <div class="row mb-2">
              <div class="col-2"><label class="form-label fw-bold">Nº Registros</label></div>
              <div class="col-2"><span>{{ datoCarga.numeroRegistros }}</span></div>
              <div class="col-2"><label class="form-label fw-bold">Fecha Desde</label></div>
              <div class="col-2"><span>{{ getFormattedDate(datoCarga.fechaDesde) }}</span></div>
              <div class="col-2"><label class="form-label fw-bold">Fecha Hasta</label></div>
              <div class="col-2"><span>{{ getFormattedDate(datoCarga.fechaHasta) }}</span></div>
            </div>
            <div class="row mb-2">
              <div class="col-2"><label class="form-label fw-bold">Nombre Archivo</label></div>
              <div class="col-10"><span class="font-monospace small">{{ datoCarga.nombreArchivo }}</span></div>
            </div>
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Observaciones</label></div>
              <div class="col-10"><span>{{ datoCarga.obs }}</span></div>
            </div>
          </div>

          <!-- ── Archivos PDF ── -->
          <div v-if="opcionModal === 'archivos'" class="modal-body">
            <div class="upload-zone">
              <div class="upload-zone-icon upload-zone-icon--teal">
                <span class="material-symbols-outlined">folder_open</span>
              </div>
              <p class="upload-zone-desc">
                Carga los archivos PDF de respaldo de las planillas. Organice la
                <a
                  href="/docs/Cómo organizar la carpeta contenedora de los archivos de respaldo.pdf"
                  target="_blank" rel="noopener noreferrer" class="upload-link"
                >carpeta contenedora</a>
                creando subcarpetas identificadas con el número de cada atención.
              </p>
              <form @submit.prevent="uploadFiles" class="w-100">
                <div class="row align-items-end g-3 justify-content-center">
                  <div class="col-md-6">
                    <label class="form-label fw-bold small">Carpeta contenedora (PDF)</label>
                    <input
                      type="file"
                      id="archivosPlanillas"
                      class="form-control form-control-sm"
                      @change="handleFilesUpload"
                      webkitdirectory
                      directory
                      multiple
                      required
                    />
                    <small class="form-text text-muted">Selecciona la carpeta con los archivos PDF de respaldo.</small>
                  </div>
                  <div class="col-md-auto">
                    <button
                      type="submit"
                      class="btn btn-outline-success d-flex align-items-center gap-1"
                      :disabled="archivosPlanillas.length === 0 || archivosPlanillas.length > 20000"
                    >
                      <span class="material-symbols-outlined" style="font-size:20px">drive_folder_upload</span>
                      <strong>Cargar archivos</strong>
                    </button>
                  </div>
                </div>
              </form>

              <div v-if="archivosPlanillas.length > 0" class="mt-3 d-flex gap-2 flex-wrap justify-content-center">
                <span class="badge bg-success fs-6">
                  {{ archivosPlanillas.length }} archivo(s) seleccionado(s)
                </span>
                <span v-if="archivosPlanillas.length > 20000" class="badge bg-danger fs-6">
                  Máx. 20000 — divide en {{ Math.ceil(archivosPlanillas.length / 20000) }} bloques
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";

export default {
  props: {
    p_idTramite: { type: Number, required: true },
    p_numSemana: { type: Number, required: true },
    p_maxSemana: { type: Number, required: true },
  },
  data() {
    return {
      cargas:               [],
      datoCarga:            {},
      titulo:               "",
      opcionModal:          "",
      elementosPorPagina:   10,
      datosPaginados:       [],
      paginaActual:         1,
      modalWindow:          true,
      p_idUsuario:          0,
      archivoDatos:         null,
      archivosPlanillas:    [],
      idCargaSeleccionada:  0,
      cargaActivaSinArchivos: false,
      isModalOpen:          false,
      uploadOptions: [
        {
          id: "json", tipo: 1,
          tabLabel: "Cargar JSON", extensionsLabel: "JSON",
          inputId: "archivoJson", accept: ".json",
          helpText: "Selecciona un archivo JSON con los datos a cargar.",
          buttonText: "Cargar JSON",
        },
        {
          id: "plano", tipo: 2,
          tabLabel: "Cargar archivos planos", extensionsLabel: ".csv",
          inputId: "archivoPlano", accept: ".csv",
          helpText: "Selecciona un archivo .csv con los datos a cargar.",
          buttonText: "Cargar CSV",
        },
        {
          id: "excel", tipo: 3,
          tabLabel: "Cargar Excel/CSV", extensionsLabel: ".xlsx o .csv",
          inputId: "archivoExcel", accept: ".xlsx,.csv",
          helpText: "Selecciona un archivo .xlsx o .csv con los datos a cargar.",
          buttonText: "Cargar Excel/CSV",
        },
      ],
    };
  },
  async mounted() {
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    await this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    handleRowClick(event, idCarga) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      this.abrirModalEditar(idCarga);
    },
    handleAction(event, idCarga, fechaDesde, fechaHasta) {
      const action = event.target.value;
      if      (action === "resumen")       this.abrirModalEditar(idCarga, fechaDesde, fechaHasta);
      else if (action === "errores")       this.abrirErrores(idCarga);
      else if (action === "novedades")     this.abrirNovedades(idCarga);
      else if (action === "zipAtenciones1") this.descargarZip(idCarga, 1);
      else if (action === "zipAtenciones2") this.descargarZip(idCarga, 2);
      else if (action === "zipAtenciones3") this.descargarZip(idCarga, 3);
      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
    totalPaginas() { return Math.max(1, Math.ceil(this.cargas.length / this.elementosPorPagina)); },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargas/idtramite/" + this.p_idTramite).then((response) => {
        this.cargas         = response.data.reverse();
        this.paginaActual   = noPagina;
        const ini           = (noPagina - 1) * this.elementosPorPagina;
        this.datosPaginados = this.cargas.slice(ini, ini + this.elementosPorPagina);
      });
      this.verificarCargasActivas();
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.getDataPaginaTodos(--this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.getDataPaginaTodos(++this.paginaActual);
    },
    abrirModal(opcion, titulo, idCarga = null) {
      this.modalWindow          = true;
      this.titulo               = titulo;
      this.opcionModal          = opcion;
      this.idCargaSeleccionada  = idCarga ?? this.idCargaSeleccionada;
      this.isModalOpen          = true;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById("ventanaModal"));
        modal.show();
        document.querySelector("#ventanaModal .btn-close")?.focus();
      });
    },
    abrirModalCrear() {
      this.datoCarga = {};
      this.abrirModal("crear", "Carga de Archivo de Datos");
    },
    abrirModalEditar(idCarga, fechaDesde, fechaHasta) {
      if (idCarga != null) {
        api.get("/vwcargas/" + idCarga).then((resp) => { this.datoCarga = resp.data; });
      }
      this.abrirModal("resumen", `Resumen de la Carga: semana desde ${fechaDesde} hasta ${fechaHasta}`);
    },
    abrirModalArchivos(idCarga) {
      this.abrirModal("archivos", "Carga de archivos de planillas", idCarga);
    },
    abrirErrores(idCarga) {
      if (idCarga != null) this.$router.push(`/cargaplanillaerrores/${this.p_idTramite}/${idCarga}`);
    },
    abrirNovedades(idCarga) {
      if (idCarga != null) this.$router.push(`/cargaplanillanovedades/${this.p_idTramite}/${idCarga}`);
    },
    handleFileUpload(event) { this.archivoDatos = event.target.files[0]; },
    async uploadFile(tipo) {
      if (!this.archivoDatos) {
        Swal.fire({ icon: "error", title: "Error", text: "No se ha seleccionado ningún archivo." });
        return;
      }
      const formData = new FormData();
      formData.append("idTramite",         this.p_idTramite);
      formData.append("idUsuario",         this.p_idUsuario);
      formData.append("fechaModificacion", this.archivoDatos.lastModified);
      formData.append("file",              this.archivoDatos);
      const endpoints = {
        1: "/cargaplanillas/cargar-archivo",
        2: "/cargaplanillass3/cargar-archivo-csv",
        3: "/cargaplanillascsvexcel/cargar-archivo-csv-excel",
      };
      try {
        Swal.fire({ title: "Un momento, por favor...", text: "Estamos cargando los datos del archivo.", allowOutsideClick: false, showConfirmButton: false, didOpen: () => Swal.showLoading() });
        const response = await api.post(endpoints[tipo], formData, { headers: { "Content-Type": "multipart/form-data" } });
        Swal.close();
        await Swal.fire({
          icon: response.data.contadorErrores === 0 ? "success" : "warning",
          title: "Archivo cargado", html: response.data.mensaje, showConfirmButton: true,
        }).then(() => {
          this.archivoDatos = null;
          this.isModalOpen  = false;
          bootstrap.Modal.getInstance(document.getElementById("ventanaModal"))?.hide();
        });
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        const msg = error.response?.data?.message || error.response?.data?.error || "Error desconocido";
        await Swal.fire({ icon: "error", title: "Error", html: `Hubo un error al cargar los archivos.<br><strong>${msg}</strong>` });
      }
      window.location.reload();
    },
    async generarAtenciones(idCarga) {
      Swal.fire({ title: "Un momento, por favor...", text: "Estamos organizando los registros de atenciones médicas.", allowOutsideClick: false, showConfirmButton: false, didOpen: () => Swal.showLoading() });
      try {
        await api.post("/cargaplanillas/generar-planillas", null, { params: { idTramite: this.p_idTramite, idCarga, idUsuario: this.p_idUsuario } });
        Swal.close();
        await Swal.fire({ title: "¡Correcto!", text: "¡Atenciones médicas organizadas exitosamente!", icon: "success", confirmButtonText: "Aceptar" });
        this.getDataPaginaTodos(this.paginaActual);
        this.$emit("estadoTramite", "ESTRUCTURADO");
      } catch {
        Swal.fire({ title: "¡Algo salió mal!", text: "Por favor, inténtelo nuevamente.", icon: "error", confirmButtonText: "Aceptar" });
      }
      window.location.reload();
    },
    async borrarCargaCompleta(idCarga) {
      Swal.fire({
        title: "Un momento, por favor...",
        text: "Estamos eliminando la carga completa.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      try {
        await api.post("/procedimientos/borrar-carga-completa", null, { params: { idTramite: this.p_idTramite, idCarga } });
        Swal.fire({ title: "¡Listo!", text: "La carga fue eliminada con éxito.", icon: "success", confirmButtonText: "Aceptar" });
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: "¡Algo salió mal!", text: "Por favor, inténtelo nuevamente.", icon: "error", confirmButtonText: "Aceptar" });
      }
    },
    async borrarCargaTramite(idCarga) {
      Swal.fire({
        title: "Un momento, por favor...",
        text: "Estamos eliminando la carga completa.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      try {
        await api.post("/procedimientos/borrar-carga-tramite", null, { params: { idTramite: this.p_idTramite, idCarga } });
        Swal.fire({ title: "¡Listo!", text: "La carga fue eliminada con éxito.", icon: "success", confirmButtonText: "Aceptar" });
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: "¡Algo salió mal!", text: "Por favor, inténtelo nuevamente.", icon: "error", confirmButtonText: "Aceptar" });
      }
    },
    handleFilesUpload(event) {
      this.archivosPlanillas = Array.from(event.target.files).filter(
        (f) => f.type === "application/pdf" || f.name.toLowerCase().endsWith(".pdf")
      );
    },
    async uploadFiles() {
      if (!this.archivosPlanillas || this.archivosPlanillas.length === 0) {
        Swal.fire({ icon: "error", title: "Error", text: "No se ha seleccionado la carpeta contenedora." });
        return;
      }
      const formData = new FormData();
      formData.append("idTramite", this.p_idTramite);
      formData.append("idCarga",   this.idCargaSeleccionada);
      formData.append("idUsuario", window.sessionStorage.getItem("idUsuario"));
      for (const archivo of this.archivosPlanillas) {
        if (archivo.size === 0) continue;
        if (!this.verificarArchivo(archivo)) {
          Swal.fire({ icon: "warning", title: "Archivo no permitido", html: `El archivo <b>${archivo.name}</b> excede el tamaño o tiene formato incorrecto.` });
          return;
        }
        formData.append("archivos", archivo);
      }
      Swal.fire({ title: "Un momento, por favor...", text: "Estamos cargando los archivos de respaldo.", allowOutsideClick: false, showConfirmButton: false, didOpen: () => Swal.showLoading() });
      try {
        const response = await api.post("/archivospla/indexar-directorio", formData, { headers: { "Content-Type": "multipart/form-data" } });
        Swal.close();
        await this.manejarRespuesta(response.data);
        this.isModalOpen = false;
        bootstrap.Modal.getInstance(document.getElementById("ventanaModal"))?.hide();
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) { console.error("Error con Axios:", error); }
    },
    async manejarRespuesta(data) {
      if (data.archivosCargados?.length > 0)
        await Swal.fire({ icon: "success", title: "Archivos cargados correctamente", html: `Se han cargado <b>${data.archivosCargados.length}</b> archivos.` });
      if (data.archivosDuplicados?.length > 0)
        await Swal.fire({ icon: "warning", title: "Archivos duplicados", html: `Se encontraron <b>${data.archivosDuplicados.length}</b> archivos duplicados.` });
      if (data.planillasNoEncontradas?.length > 0)
        await Swal.fire({ icon: "error", title: "Planillas no encontradas", html: `<b>${data.planillasNoEncontradas.length}</b> planillas no encontradas.` });
      if (data.archivosCargados?.length > 0)       this.descargarCSV(data.archivosCargados,       "archivosCargados.csv");
      if (data.archivosDuplicados?.length > 0)     this.descargarCSV(data.archivosDuplicados,     "archivosDuplicados.csv");
      if (data.planillasNoEncontradas?.length > 0) this.descargarCSV(data.planillasNoEncontradas, "planillasNoEncontradas.csv");
    },
    descargarCSV(data, nombreArchivo) {
      if (!data || data.length === 0) return;
      let csv = "data:text/csv;charset=utf-8,Nombre de archivo\n";
      data.forEach((a) => { csv += a + "\n"; });
      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csv));
      link.setAttribute("download", nombreArchivo || "archivos_cargados.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verificarArchivo(archivo) {
      const tipos = ["application/pdf", "image/jpeg", "image/png"];
      return tipos.includes(archivo.type) && archivo.size <= 20 * 1024 * 1024;
    },
    async verificarCargasActivas() {
      if (!this.p_idTramite) return;
      try {
        const response = await api.get(`/vwcargas/tramite/${this.p_idTramite}/cargas-activas-sin-archivos`);
        this.cargaActivaSinArchivos = response.data;
      } catch (error) { console.error("Error al consultar el servicio:", error); }
    },
    async descargarZip(idCarga, opcion) {
      const mapa = {
        1: { url: "/vwtramites/descargar-carpetas",                     nombre: "carpetas_atenciones.zip" },
        2: { url: "/vwtramites/descargar-carpetas-fecha",               nombre: "carpetas_por_fecha.zip" },
        3: { url: "/vwtramites/descargar-carpetas-fecha-especialidad",   nombre: "carpetas_por_fecha_y_especialidad.zip" },
      };
      const ep = mapa[opcion];
      if (!ep) return;
      const response = await api.get(ep.url, { params: { idTramite: this.p_idTramite, idCarga }, responseType: "blob" });
      const url  = URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
      const link = document.createElement("a");
      link.href     = url;
      link.download = `${this.p_idTramite}_${ep.nombre}`;
      link.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
/* ── Barra de acciones ───────────────────────────────────────── */
.action-bar { display: flex; flex-wrap: wrap; gap: 8px; }
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: filter .12s, transform .1s;
}
.action-btn:hover { filter: brightness(1.08); transform: translateY(-1px); }
.action-btn .material-symbols-outlined { font-size: 18px; }
.action-btn--primary { background: #0d6efd; color: #fff; }

/* ── Botones icon-only ───────────────────────────────────────── */
.icon-btns { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px; height: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  background: transparent;
  transition: background .13s, transform .1s;
  padding: 0;
}
.icon-btn:hover { transform: translateY(-1px); }
.icon-btn .material-symbols-outlined { font-size: 17px; }
.icon-btn--green    { color: #2e7d32; border-color: #c8e6c9; }
.icon-btn--green:hover  { background: #e8f5e9; }
.icon-btn--red      { color: #c62828; border-color: #ffcdd2; }
.icon-btn--red:hover    { background: #ffebee; }
.icon-btn--red-soft { color: #e53935; border-color: #eeeeee; }
.icon-btn--red-soft:hover { background: #fff3f3; border-color: #ffcdd2; }
.icon-btn--teal     { color: #00897b; border-color: #b2dfdb; }
.icon-btn--teal:hover   { background: #e0f2f1; }

/* ── Upload zone ─────────────────────────────────────────────── */
.upload-zone {
  border: 2px dashed #dee2e6;
  border-radius: 10px;
  padding: 28px 24px;
  background: #f8fafd;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.upload-zone-icon {
  width: 52px; height: 52px;
  border-radius: 50%;
  background: #e8f0fe;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 12px;
}
.upload-zone-icon .material-symbols-outlined { font-size: 28px; color: #1a73e8; }
.upload-zone-icon--teal { background: #e0f2f1; }
.upload-zone-icon--teal .material-symbols-outlined { color: #00897b; }
.upload-zone-desc { color: #6c757d; font-size: 0.88rem; max-width: 560px; margin-bottom: 18px; }
.upload-link { color: #1a73e8; font-weight: 600; }

/* ── Tabla ───────────────────────────────────────────────────── */
.table-hover tbody tr { cursor: pointer; }
</style>